import { gql } from 'providers/tanstack-query/utils'

import type { AuthUserDTO } from './types'
import type { Ability } from 'providers/casl'
import type { TypedDocumentNode } from 'providers/tanstack-query/types'

export const authUserCurrentWorkspaceFields = (ability: Ability): string => `
  active
  alerts {
    description
    name
  }
  id
  ${ability.can('access', 'GlobalSetupPage-googleAdManagerConnection') ? 'latestGamConnectionOrder { status }' : ''}
  name
  networkCode
  pipedriveLink
  prebidManagerSampling
  priceGeniusAlwaysOn
  primaryCurrency
`

export const AUTH_USER_FRAGMENT = (ability: Ability): TypedDocumentNode<AuthUserDTO> => gql`
  fragment AuthUserFragment on User {
    currentWorkspace {
      ${authUserCurrentWorkspaceFields(ability)}
    }
    currentWorkspaceRole
    email
    features {
      enabled
      name
    }
    firstName
    id
    lastName
    role
    workspaceProducts {
      product
      status
    }
    workspaces {
      alerts {
        description
        name
      }
      id
      name
      networkCode
    }
  }
`
